import { SkuTypes } from '../../interfaces/bbc'
import { INVENTORY_DISTRIBUTION_FILTERS } from './bbc'
import { FilterFieldType, IFilter } from './types'

export const SALES_DISTRIBUTION_BY_GRAPH_FILTERS_CONFIG = [
  {
    field: 'distribution',
    type: FilterFieldType.Text,
    align: 'left',
    title: 'Distribution',
    isSortable: true,
    dbField: 'distribution',
  },
  ...INVENTORY_DISTRIBUTION_FILTERS,
] as const

export const SALES_BY_SKU_VISUALIZATION_FILTERS_CONFIG = [
  {
    field: 'distribution',
    type: FilterFieldType.Text,
    align: 'left',
    title: 'Distribution',
    isSortable: true,
    dbField: 'distribution',
  },
  ...INVENTORY_DISTRIBUTION_FILTERS,
  {
    field: 'onHand',
    type: FilterFieldType.Number,
    isSortable: true,
    align: 'right',
    title: 'Units On Hand',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'previousOnHandDifference',
    type: FilterFieldType.Number,
    isSortable: true,
    align: 'right',
    title: 'Unit Change',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'totalValue',
    type: FilterFieldType.Amount,
    isSortable: true,
    align: 'right',
    title: 'Total Inventory',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'previousTotalValueDifference',
    type: FilterFieldType.Amount,
    isSortable: true,
    align: 'right',
    title: 'Value Change',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'totalInventoryPercent',
    type: FilterFieldType.Percent,
    isSortable: true,
    align: 'right',
    title: '% of Inventory',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'unitSales',
    type: FilterFieldType.Number,
    isSortable: true,
    title: 'Sales Units',
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'totalSales',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Sales',
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'totalSalesPercent',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: '% of Sales',
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'totalCOGS',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'COGS',
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'weeklyCOGS',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Weekly COGS',
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'weeksOfSupply',
    type: FilterFieldType.Number,
    title: 'WOS',
    isSortable: true,
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'totalIneligible',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Total Ineligible',
    align: 'right',
    excludeFilter: true,
    isHighlighted: true,
  },
  {
    field: 'monthsOfSales',
    type: FilterFieldType.Number,
    title: 'Months of Sales',
    isSortable: true,
    align: 'right',
    excludeColumn: true,
    excludeFilter: true,
  },
  {
    field: 'monthsOfSalesCount',
    type: FilterFieldType.Number,
    title: 'Months of Sales Count',
    isSortable: true,
    align: 'right',
    excludeColumn: true,
    excludeFilter: true,
  },
  {
    type: FilterFieldType.QuickFilter,
    field: 'quickFilter',
    quickFilters: [
      {
        title: 'Finished Goods',
        filters: {
          type: [SkuTypes.Finished],
        },
      },
    ],
  },
] as const satisfies IFilter[]

export const SALES_CHANNEL_DISTRIBUTION_LIST_FILTERS_CONFIG = [
  {
    field: 'label',
    type: FilterFieldType.Text,
    title: 'Month',
    align: 'left',
    isSortable: true,
  },
  {
    field: 'customer_deposits',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Customer Deposits',
  },
  {
    field: 'gross_revenue',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Gross Revenue',
  },
  {
    field: 'net_revenue',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'Net Revenue',
  },
  {
    field: 'ar_gl_invoices',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'AR GL Invoices',
  },
  {
    field: 'ar_gl_payments',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'AR GL Collections',
  },
  {
    field: 'ar_gl_dilutive_credits',
    type: FilterFieldType.Amount,
    isSortable: true,
    title: 'AR GL Credits',
  },
  {
    field: 'dilution',
    type: FilterFieldType.Percent,
    isSortable: true,
    title: 'Dilution',
  },
] as const satisfies IFilter[]
